{
    "title": "Company Contact",
    "input":{
        "websiteAddress": "Website Address",
        "emailAddress": "Corporate Contact E-mail",
        "telephoneNumber": "Telephone Number"
    }
}